<template>
  <a-modal :visible="visible" @cancel="$emit('cancel')" :footer="null" centered>
    <div>
      <LoginForm />
      <MobileForm />
    </div>
  </a-modal>
</template>
<script>
import LoginForm from './form.vue';
import MobileForm from './mobile.vue';
export default {
  props: {
    visible: Boolean,
  },
  components: {
    LoginForm,
    MobileForm,
  },
};
</script>
